var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditListItemIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-edit-1072354",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.999,
    viewBox: "0 0 16 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10178",
    "data-name": "Caminho 10178",
    d: "M79.942,2.67,83.2,5.941l-8.239,8.278L71.7,10.949Zm5.724-.789L84.215.423a1.435,1.435,0,0,0-2.035,0l-1.39,1.4L84.044,5.09l1.622-1.63a1.119,1.119,0,0,0,0-1.58ZM70,15.546a.371.371,0,0,0,.448.443l3.627-.884-3.253-3.271Z",
    transform: "translate(-69.993 0)",
    fill: "#9d9d9d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditListItemIcon);
export default __webpack_public_path__ + "static/media/edit_list_item_icon.361c311fcfc09c96a8c8d6709d9aedc4.svg";
export { ForwardRef as ReactComponent };